import React from 'react';
import Chart from "react-apexcharts";

const BarChart = ({ series, options }) => {
    if (!series?.length || !options) return null;
    // console.log("series, options", series, options);
    return (
        <Chart options={options} series={series} type="bar" height={220}  />
    );
};

export default BarChart;